import { useEffect, useRef } from 'react'

export function useDebounce(onTimeout: () => void, debounceTime: number, debounceOn: unknown[] = []) {
  const timerRef = useRef<ReturnType<typeof setTimeout>>()
  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => onTimeout(), debounceTime)
  }, debounceOn) // eslint-disable-line react-hooks/exhaustive-deps
}
